export const init = () => {
  /*
          SHOPPING TOOL - DASHBOARD
      */

  if ($('.account').length === 0) return;

  const fwk = CUBE.Analytics;
  const sep = AnalyticsConstants.separatorST;

  const stType = 'merchandising';

  // DASHBOARD LVP
  $('.dash-card.last-products').on(
    'click',
    '.lvp-element a:not(.delete)',
    function() {
      const $lvp = $(this);
      const positionProduct =
        $('.lvp-element').index($lvp.closest('.lvp-element')) + 1;
      const stDetails =
        `lvp-customer-dashboard${  sep  }position${  sep  }${positionProduct}`;
      fwk.shoppingtool.set(stType, stDetails);
    }
  );
};



// WEBPACK FOOTER //
// ./src/analytics/shopping-tool/st-dashboard.js